import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import { Checkbox, Select } from '../'
/*
    Monday      = 1 = 1
    Tuesday     = 2 = 2
    Wednesday   = 3 = 4
    Thursday    = 4 = 8
    Friday      = 5 = 16
    Saturday    = 6 = 32
    Sunday      = 7 = 64
*/

const choices = t => [{
	label: t('common.dates.all_days'),
	value: 127
}, {
	label: t('common.dates.monday'),
	value: 1
}, {
	label: t('common.dates.tuesday'),
	value: 2
}, {
	label: t('common.dates.wednesday'),
	value: 4
}, {
	label: t('common.dates.thursday'),
	value: 8
}, {
	label: t('common.dates.friday'),
	value: 16
}, {
	label: t('common.dates.saturday'),
	value: 32
}, {
	label: t('common.dates.sunday'),
	value: 64
}]

export const parseWeekDaysNum = (num, t) => {
	let res = []
	const options = choices(t)
	const selectOptions = options.filter((option, i) => i !== 0), // Excluding 'all' value
		possibleOptions = selectOptions.map((option, i) => Math.pow(2, i))

	if(possibleOptions.indexOf(num) >= 0) {
		res.push(selectOptions[possibleOptions.indexOf(num)])
	} else if(num === 127) {
		res = options[0]
	} else {
		possibleOptions.reduceRight((sum, val, ind, arr) => {
			let newSum = sum
			if(num >= newSum + val) {
				newSum += val
				res.push(selectOptions[ind])
				if(ind === 0 && newSum !== num) {
					res = '' // Incorrect 'num'
					// console.log('Received incorrect sum of options')
				}
			}
			return newSum
		}, 0)
	}
	return Array.isArray(res) ? res.sort((day1, day2) => day1.value - day2.value) : res
}

class WeekdayPicker extends Component {
	optionRenderer = ({ innerProps, data, value, getValue, selectOption, label, ...rest }) => {
		let totalValue = 0
		getValue().forEach(option => {
			totalValue += option.value
		})
		return(
			<div style={{ padding: '10px' }} className='Select__option'>
				<Checkbox
					onClick={() => selectOption(data)}
					noForm
					checked={(value === 127 ? (totalValue === 127) : value & totalValue)}
					label={label}
				/>
			</div>
		)
	}

	transformValue = val => {
		if(!val.length) {
			return this.props.removeOnClear ? null : 0
		}
		if(!Array.isArray(val)) {
			return val
		}
		if(this.props.onChange) {
			this.props.onChange(val)
		}
		const valAll = 127,
			positionAllOption = val.findIndex(({ value }) => (valAll === value)),
			valsSum = val.reduce((sum, { value }) => sum + value, 0)
		if(positionAllOption < 0) {
			return valsSum // Return sum of checked options if 'all' is not checked
		}

		/* If selecting 'all' value when another options are selected already ('all' value is pushed to the end of array of values
	so 'positionAllOption' is not '0') return 'all' value.
		If selecting any value when 'all' value is already selected ('all' value is at the first position in array of values)
	return all values except selected value */
		return (positionAllOption) ? valAll : valAll - (valsSum - valAll)
	}

	selectOptions = choices(this.props.t)

	render({ field = 'weekDays', t, i18n, ...rest } = this.props) {
		return(
			<Select
				label={this.props.t('common.fields.week_days')}
				placeholder='Keine Tage'
				{...rest}
				isMulti={true}
				simpleValue={false}
				field={field}
				hideSelectedOptions={false}
				beforeSetFormValue={this.transformValue}
				beforeSetSelectValue={num => parseWeekDaysNum(num, t)}
				options={this.selectOptions}
				components={{
					Option: this.optionRenderer
				}}
				closeMenuOnSelect={false}
			/>
		)
	}
}

export default withTranslation()(WeekdayPicker)
